<template>
  <v-dialog v-model="viewDialog" persistent max-width="700">
    <v-card :loading="loading" loader-height="2">
      <v-card-title>View {{ name }}</v-card-title>
      <v-card-text>
        <div class="mylist">
          <ul>
            <li>
              <div class="myleft">name</div>
              <div class="myright">{{ view.name }}</div>
              <div class="clearall"></div>
            </li>
            <li>
              <div class="myleft">description</div>
              <div class="myright">{{ view.description }}</div>
              <div class="clearall"></div>
            </li>
            <li>
              <div class="myleft">registration_number</div>
              <div class="myright">{{ view.registration_number }}</div>
              <div class="clearall"></div>
            </li>
            <li>
              <div class="myleft">aquired_since</div>
              <div class="myright">{{ view.aquired_since | myDate }}</div>
              <div class="clearall"></div>
            </li>
            <li>
              <div class="myleft">document_typesid</div>
              <div class="myright">{{ view.document_typesid }}</div>
              <div class="clearall"></div>
            </li>
            <li>
              <div class="myleft">active</div>
              <div class="myright">{{ view.active }}</div>
              <div class="clearall"></div>
            </li>
            <li>
              <div class="myleft">updated</div>
              <div class="myright">{{ view.updated | myDating }}</div>
              <div class="clearall"></div>
            </li>
          </ul>
        </div>
      </v-card-text>
      <v-card-actions>
        <span class="error_message">{{ responseMessage }}</span>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn small text color="red" v-on="on" @click="closeDialog">
              NO
            </v-btn>
          </template>
          <span>cancel</span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Restful from "@/services/RestFul";
//   import moment from "moment";
//   import Utils from "./../../../../mixins/utils";
export default {
  props: {
    viewDialog: Boolean,
    myId: { type: Number, default: 0 },
    name: { type: String, default: null },
  },
  // mixins: [Utils],
  data() {
    return {
      responseMessage: null,
      loading: false,
      view: {
        name: null,
        description: null,
        registration_number: null,
        aquired_since: null,
        document_typesid: null,
        file_name: null,
        active: null,
        created: null,
        updated: null,
      },
    };
  },
  created() {
    this.find();
  },
  methods: {
    find() {
      this.loading = true;
      let self = this;
      Restful.subscribers.certificate
        .find(this.myId)
        .then((response) => {
          console.log(response.data);
          this.view.name = response.data.name;
          this.view.description = response.data.description;
          this.view.registration_number = response.data.registration_number;
          this.view.aquired_since = response.data.aquired_since;
          this.view.document_typesid = response.data.document_typesid;
          this.view.file_name = response.data.file_name;
          this.view.active = response.data.active;
          this.view.created = response.data.created;
          this.view.updated = response.data.updated;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error.response);
          self.snack.color = "error";
          self.snack.text = error.response.data;
          self.loading = false;
        });
    },
    closeDialog() {
      let payload = { id: this.myId, state: false };
      this.$emit("closeView", payload);
    },
  },
};
</script>
